import { Component, OnDestroy, OnInit, viewChild, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { AwardOfContractComponent } from '../award-of-contract/award-of-contract.component';
import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
import { PreliminaryDesignComponent } from '../preliminary-design/preliminary-design.component';
import { CriticalDesignComponent } from '../critical-design/critical-design.component';
import { IdexUtrrComponent } from '../idex-utrr/idex-utrr.component';
import { ProductionSupplyComponent } from '../production-supply/production-supply.component';
import { TotComponent } from '../tot/tot.component';
import { PrototypeDeliveryComponent } from '../prototype-delivery/prototype-delivery.component';
import { PreparationOfPsqrFrommPddComponent } from '../preparation-of-psqr-fromm-pdd/preparation-of-psqr-fromm-pdd.component';
import { SsctComponent } from '../ssct/ssct.component';
import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
import { AONComponent } from '../stape-component/aon/aon.component';
import { ConstituteContractNegotiationCommitteeComponent } from '../constitute-contract-negotiation-committee/constitute-contract-negotiation-committee.component';
import { BanchmarkComponent } from '../stape-component/banchmark/banchmark.component';
import { IdexComponent } from '../idex/idex.component';
import { PreliminaryDiscussionComponent } from '../preliminary-discussion/preliminary-discussion.component';
import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
import { ConcurrenceRfiComponent } from '../concurrence-rfi/concurrence-rfi.component';
import { DrdoAipComponent } from '../drdo-aip/drdo-aip.component';
import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
import { FirmResponseEvaluationComponent } from '../firm-response-evaluation/firm-response-evaluation.component';
import { CommercialEvaluationComponent } from '../stape-component/financial-evaluation/commercial-evaluation.component';
import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';
import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { Table } from 'primeng/table';
import { LaunchChallengeComponent } from '../launch-challenge/launch-challenge.component';
import { SparkAgreementComponent } from '../spark-agreement/spark-agreement.component';
import { PsqrComponent } from '../psqr/psqr.component';
import { PsqrToSqrComponent } from '../psqr-to-sqr/psqr-to-sqr.component';
import { MilestoneComponent } from './milestone/milestone.component';
import {TechnicalNegotiationsComponent} from '../stape-component/technical-negotiations/technical-negotiations.component';
import {AonSocComponent } from '../aon-soc/aon-soc.component';

@Component({
  selector: 'app-idex-aditi-transaction',
  standalone: false,
  templateUrl: './idex-aditi-transaction.component.html',
})
export class IdexAditiTransactionComponent implements OnInit {
  @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
  @ViewChild('documentTable') documentTable?: Table;
  @ViewChild(IdexComponent) idexComponent?: IdexComponent;
  @ViewChild(LaunchChallengeComponent) launchChallengeComponent?: LaunchChallengeComponent;
  @ViewChild(FirmResponseSubmissionComponent) firmResponseSubmissionComponent?: FirmResponseSubmissionComponent;
  @ViewChild(SparkAgreementComponent) sparkAgreementComponent?: SparkAgreementComponent;
  @ViewChild(PsqrComponent) psqrComponent?: PsqrComponent;
  @ViewChild(PsqrToSqrComponent) psqrToSqrComponent?: PsqrToSqrComponent;
  @ViewChild(SsctComponent) ssctComponent?: SsctComponent;
  @ViewChild(MilestoneComponent) milestoneComponent?: MilestoneComponent;
  @ViewChild(FirmResponseEvaluationComponent) firmResponseEvaluationComponent?: FirmResponseEvaluationComponent;
  @ViewChild(TechnicalNegotiationsComponent) technicalNegotiationsComponent?: TechnicalNegotiationsComponent;
  @ViewChild(BanchmarkComponent) banchmarkComponent?: BanchmarkComponent;
  @ViewChild(AonSocComponent) aonSocComponent?: AonSocComponent;
  baseUrl = environment.APIUrl;
  masterData: any[] = [];
  pdfdata: any;
    DocName = '';
    displayDialog = false;
    proposalId!: number | string;
    proposalName = '';
    schemeId!: number | string;
  phaseId!: number | string;
  step_details: any;
  userGuide: string = 'process';
  reportList: any[] = [];
  documentList: any[] = [];
  searchText = '';
  tabList: any[] = [];
  confirmChecked = false;
  role_id=sessionStorage.getItem('user_role_id');
  comment: string = '';
  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    

  ) {}

  ngOnInit(): void {
  this.route.queryParams.subscribe(params => {

  this.proposalId = params['id'];
  this.proposalName = params['name'] ?? '';
  this.phaseId = params['phase'];
  this.schemeId = params['scheme'];

  console.log('proposalId:', this.proposalId);
  console.log('proposalName:', this.proposalName);
  console.log('phaseId:', this.phaseId);
  console.log('schemeId:', this.schemeId);

});
    // this.fetchMasterData();
    this.fetchTabs();
  }



  getReportList(): void {
    if (!this.step_details?.id || !this.proposalId) return;
    this.reportList = [];
    const sub = this.api
      .getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.reportList = res || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch report versions.'
        })
      });
  }

  getDocumentList(): void {
    if (!this.proposalId) return;
    this.documentList = [];
    const sub = this.api
      .getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.documentList = res?.data || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch documents.'
        })
      });
  }

  pdfconvert(htmlContent: string): void {
    if (!htmlContent) return;
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url; anchor.download = 'report.html'; anchor.click();
    window.URL.revokeObjectURL(url);
  }

  submitIRA(): void {
    if (!this.step_details?.id) return;
    const payload = {
      editor_turn: this.step_details.editor_id,
      remarks: this.comment,
    };
    const sub = this.api.postAPI(`/file_mange/editor/approve/`, payload).subscribe(res=>{
      this.comment = '';
      if(res.status !=='Approved') {

        this.transHeaderSteperComponent?.navigate(1,true);
      }else{
        this.transHeaderSteperComponent?.navigate(1,false,true);
      }
      }
    );
  }
  generatePDF(event: any): void {
    this.pdfdata = event; this.displayDialog = true;
  }

  isHTMLorText(input: any): boolean {
    if (typeof input !== 'string') return false;
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  saveVersion(): void {
    const data = document.getElementById('printSection')?.innerHTML;
    if (!data || !this.step_details?.id || !this.pdfdata?.url) {
      console.error('Missing required data for saving version.');
      return;
    }
    const payload = {
      proposal_step: this.step_details.id,
      name: this.DocName || 'Version',
      paragraph: data
    };
    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: res => {
        this.DocName = '';
        this.messageService.add({
          severity: 'success', summary: 'Success', detail: res?.message || 'Version saved successfully.'
        });
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to save version.'
      })
    });
  }

  private fetchMasterData(): void {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.masterData = data.map((item: any) => ({
          id: item.id,
          name: item.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2)
        }));
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch master data.'
      })
    });
  }

  private fetchTabs(): void {
    if (!this.schemeId) return;
    const sub = this.api.getAPI(`/master/scheme/${this.schemeId}/phases/`).subscribe({
      next: (res: any) => {
        this.tabList = res || [];
        this.tabList.sort((a: any, b: any) => a.sequence - b.sequence);
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch phases.'
      })
    });
  }

 showConfirm(): void {
    this.messageService.clear('confirm');
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Are you sure you want to submit this proposal?'
    });
  }
  topRender=true;
  submitProposal(action: 1 | 2): void {
    this.idexComponent?.submitOcProposal();
    // console.log('submitProposal',this.idexComponent);
    this.idexComponent?.onSubmit();
    this.launchChallengeComponent?.onSubmit();
    this.firmResponseSubmissionComponent?.onSubmit();
    this.sparkAgreementComponent?.onSubmit();
    this.psqrComponent?.onSubmit(); 
    this.psqrToSqrComponent?.onSubmit();
    this.ssctComponent?.onSubmit();
    this.milestoneComponent?.onSubmit();
    this.firmResponseEvaluationComponent?.onSubmitHpscForm();
    this.technicalNegotiationsComponent?.onSubmit();
    this.banchmarkComponent?.submitProposalData();
    this.aonSocComponent?.onSaveAndRoute();
    this.messageService.clear('confirm');
    if (action === 2) {
      this.submitIRA();
    }
  }


  checkIsNextRouteConfig() {
    const t = this.api.getData() || [];

  
    // current working directorate (top level)
    const currentIndex = t.findIndex(s => (s?.status ?? "") === "working");
    if (currentIndex === -1) return false;
  
    // 1) current directorate ke internalUsers me (current working user ke baad) koi edit hai kya?
    const curr = t[currentIndex];
    if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
      const internalIndex = curr.internalUsers.findIndex(u => (u?.status ?? "") === "working");
  
      if (internalIndex !== -1) {
        const hasNextInternalEdit = curr.internalUsers
          .slice(internalIndex + 1)
          .some(u => (u?.permission ?? "") === "edit");
  
        if (hasNextInternalEdit) return true;
      } else {
        // Agar koi internal "working" marked hi nahi hai, still check any internal edit
        if (curr.internalUsers.some(u => (u?.permission ?? "") === "edit")) return true;
      }
    }
  
    // 2) currentIndex ke baad ke sabhi next directorates + unke internalUsers me koi edit hai kya?
    for (let i = currentIndex + 1; i < t.length; i++) {
      const next = t[i];
  
      // next directorate itself has edit
      if ((next?.permission ?? "") === "edit") return true;
  
      // next directorate ke kisi bhi internal user ke paas edit
      if (next?.hasInternal && Array.isArray(next.internalUsers) && next.internalUsers.length) {
        const anyInternalEdit = next.internalUsers.some(u => (u?.permission ?? "") === "edit");
        if (anyInternalEdit) return true;
      }
    }
  
    return false;
  }
  trigarFromChild(): void {
    this.messageService.clear('confirm');
    this.transHeaderSteperComponent?.openDialog();
  }
  currentStepChange(event: any): void {
    this.step_details = event;
    this.userGuide='process';
  }

  apiResponse: any;
  getReportData(): void {
    this.api.getAPI(`/idex/proposal/report/${this.proposalId}/`).subscribe((res) => {
      const codesToReset = ["I-SC", "C-APPR", "IPV"];
          const data  = res.steps.map((item: any) => {
            if (codesToReset.includes(item.step_code)) {
              return { ...item, data: {} };
            }
          return item;
          });
          this.apiResponse=res
          this.apiResponse.steps =data;
          console.log(this.apiResponse,data);
    });
  }
}
